import { MainView } from '@repo/ui/Views';
import HomeQuickLinks from '../components/HomeQuickLinks';
import { useUser } from '@repo/hooks/useUser';

const AccountOverview = () => {
  const user = useUser();

  const name =
    user?.first_name && user?.last_name ? `${user.first_name} ${user.last_name}` : user?.name;

  return (
    <MainView title={`Welcome,  ${name}`}>
      <HomeQuickLinks />
    </MainView>
  );
};

export default AccountOverview;
